import Skeleton from 'react-loading-skeleton';

const LoadingSkeleton: React.FC = () => {
    return (
        <tr>
            <td><Skeleton/></td>
            <td><Skeleton/></td>
            <td><Skeleton/></td>
        </tr>
    )
}

export default LoadingSkeleton;